import React, {useEffect, useState} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';

import {AuthConsumer} from '../../providers/AuthProvider';
import colors from '../../util/colors';
import * as fonts from '../../util/fonts';
import {strings} from '../../util/strings';
import {Column, Row} from '../../components/layout';
import './styles.scss';
import {
  AppForm,
  AppFormField,
  AppFormSubmitButton,
} from '../../components/forms';
import AppErrorMessage from '../../components/app-error-message';
import Icon from '../../components/icon';
import {Icons} from '../../util/icons';
import * as Yup from 'yup';
import {
  putUserPersonalDate,
  uriPatchContacts,
  uriSendOTPCode,
  uriUpdateUserdata,
} from '../../api/endpoints';
import {patch, post, put} from '../../api/api';
import ModalTemplate from '../../components/modal';
import {decodeToken, numberWithSpaces} from '../../util/utility';
import {addToUser, setUser} from '../../store/actions';
import ConfirmPasswordModal from '../../components/headers/app-header/virtual-card/customer-not-found/confirm-password-modal/ConfirmPasswordModal';
import ChangePasswordModal from './change-password-modal';
import AppLanguageSelector from '../../components/app-language-selector';
import ValidateContactModal from './validate-contact-modal';

interface AccountDataProps {
  labels: any;
  buStyles: any;
  user: any;
  messageLabels: typeof strings.pt.messages;
  stringsDefault: typeof strings;
  language: any;
  selectedBu: any;
  accessToken: any;
  setUser(value: any): void;
  addToUser(value: any): void;
}

const AccountData = ({
  labels,
  buStyles,
  user,
  messageLabels,
  stringsDefault,
  language,
  selectedBu,
  accessToken,
  setUser,
  addToUser,
}: AccountDataProps) => {
  const [initialValues, setInitialValues] = useState({
    name: user.name,
    email: user.email,
    phone: user.mobile && user.mobile !== '0' ? user.mobile : '',
  });
  const [editing, setEditing] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [saveOperationResult, SetSaveOperationResult] = useState(false);
  const [showSaveResultModal, setShowSaveResultModal] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [valueChanged, setValueChanged] = useState('');
  const [fieldToEdit, setFieldToEdit] = useState(0);
  const [changed, setChanged] = useState(false);
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState<any>();
  const [showValidateModal, setShowValidateModal] = useState(false);
  const [hoverErrorIcons, setHoverErrorIcons] = useState<any>({
    name: false,
    email: false,
    phone: false,
  });
  const [showModal, setShowModal] = useState(false);
  const [showCodeErrorModal, setShowCodeErrorModal] = useState(false);
  const [showCodeResendError, setShowCodeResendError] = useState(false);
  const [codeErrorMsg, setCodeErrorMsg] = useState('');
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);
  const [sendingNewCode, setSendingNewCode] = useState(false);
  const [showResendConfirmation, setShowResendConfirmtation] = useState(false);
  const [showSubmitCodeError, setShowSubmitCodeError] = useState(false);
  const [showWrongCodeError, setShowWrongCodeError] = useState(false);
  const allLabels = {...strings.pt.myProfile, ...strings.pt.myData, ...labels};
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required(messageLabels?.requiredField)
      .matches(
        new RegExp(
          '^(?![\\s\\S]{51,})([^0-9\\s]+(?:\\s[^0-9\\s]{1,30}){1,9})$'
        ),
        labels?.myProfile_nameValidationError
      ),
    email: Yup.string()
      .required(messageLabels?.requiredField)
      .email(messageLabels.invalidEmailFormat)
      .label('E-mail'),
    phone: Yup.string()
      .required(messageLabels?.requiredField)
      .max(13)
      .matches(new RegExp('^[0-9+]{9,}$'), messageLabels?.invalidFormat),
  });

  const featureName = 'MyProfile';

  useEffect(() => {
    setChanged(compareValues());
  }, [values]);

  const compareValues = (): boolean =>
    initialValues.name !== values.name ||
    initialValues.email !== values.email ||
    initialValues.phone !== values.phone;

  const defineOnMouseFunctions = (
    e: React.MouseEvent,
    fieldNamePar: string
  ) => {
    var elem: HTMLElement = e.target as HTMLElement;
    var icon: HTMLElement = elem.nextSibling as HTMLElement;
    if (icon) {
      icon.onmouseover = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: true});
      };
      icon.onmouseout = function () {
        setHoverErrorIcons({...hoverErrorIcons, [fieldNamePar]: false});
      };
    }
  };

  const submitNameChange = async (values: any, signinSilent: any) => {
    setSubmitting(true);
    let body: any;
    body = {
      userName: user.sub,
      fullName: values.name,
      nif: user.nif,
      //phoneNumber: values.phone,
      //email: values.email,
      language: user?.language || language,
    };

    try {
      const response = await patch(uriUpdateUserdata(), body, featureName);
      if (response !== false) {
        try {
          const bodyPersonalDate = {
            username: user.sub,
          };
          await put(putUserPersonalDate(), bodyPersonalDate);
        } catch {}
        SetSaveOperationResult(true);
        setShowSaveResultModal(true);
        setInitialValues({
          name: values.name,
          email: values.email,
          phone: values.phone,
        });
        setChanged(false);
        const decodedInfo = decodeToken(accessToken);
        const userInfo = {...decodedInfo};
        setUser(userInfo);
        setUser({
          ...user,
          name: `${values.name?.split(' ')[0]} ${values.name.substring(
            values.name.indexOf(' ') + 1
          )}`,
          //phone_number: values.phone,
          //email: values.email,
        });
        const isNotFound: any = user.state === 'NOT_FOUND';
        if (selectedBu.buId !== 'NOTCLIENT') {
          addToUser({
            state: 'CLIENT',
          });
        } else {
          if (isNotFound) {
            addToUser({
              state: 'NOT_FOUND',
            });
          } else {
            addToUser({
              state: 'NOT_CLIENT',
            });
          }
        }

        setInitialValues({
          name: values.name,
          email: values.email,
          phone: values.phone,
        });
        signinSilent();
      } else if (!response) {
        SetSaveOperationResult(false);
        setShowSaveResultModal(true);
      }
    } catch (err: any) {
      SetSaveOperationResult(false);
      setShowSaveResultModal(true);
    } finally {
      setSubmitting(false);
    }
  };

  const sendCode = async (
    value: any,
    fieldEdited: number,
    isResend = false
  ) => {
    try {
      setSendingNewCode(true);
      setSubmitting(true);
      setShowResendConfirmtation(false);
      setShowCodeResendError(false);
      isResend && setShowWrongCodeError(false);

      const body = {
        contact: value,
        senderType: fieldEdited === 2 ? 'EMAIL' : 'SMS',
      };

      await post(uriSendOTPCode(), JSON.stringify(body));
      isResend && setShowResendConfirmtation(true);
      setShowValidateModal(true);
    } catch (error: any) {
      if (error.status === 403) {
        setCodeErrorMsg(labels?.myData_sendCode_error);
      } else {
        setCodeErrorMsg(messageLabels?.general_errorMessage);
      }
      isResend ? setShowCodeResendError(true) : setShowCodeErrorModal(true);
    } finally {
      setSubmitting(false);
      setSendingNewCode(false);
    }
  };

  const submitCode = async (value: any, fieldEdited: number) => {
    try {
      setShowSubmitCodeError(false);
      setShowWrongCodeError(false);
      setShowCodeResendError(false);

      const body = {
        code: value,
        contact: valueChanged,
        senderType: fieldEdited === 2 ? 'EMAIL' : 'SMS',
      };
      await patch(uriPatchContacts(), body);

      if (fieldEdited === 2) {
        setUser({...user, email: valueChanged});
        setValues({...values, email: valueChanged});
      } else if (fieldEdited === 3) {
        setUser({...user, mobile: valueChanged});
        setValues({...values, phone: valueChanged});
      }
      setShowSaveResultModal(true);
      SetSaveOperationResult(true);
    } catch (error: any) {
      if (error.status === 400) {
        setShowWrongCodeError(true);
      } else {
        setShowSubmitCodeError(true);
      }
      SetSaveOperationResult(false);
    }
  };

  return (
    <>
      <p
        className="profile-subtitle"
        style={{
          ...fonts.M,
          color: colors.black,
        }}>
        {allLabels?.myProfile_dataOfRegister}
      </p>
      <AuthConsumer>
        {({signinSilent}) => (
          <AppForm
            className={`profile-form${!editing && ' read-only'}`}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values: any, {validateForm}: any) => {
              const errors = await validateForm(values);
              if (Object.keys(errors).length > 0) {
                return;
              }
              if (fieldToEdit === 1) {
                submitNameChange(values, signinSilent);
              } else {
                setValueChanged(
                  fieldToEdit === 2 ? values.email : values.phone
                );
                sendCode(
                  fieldToEdit === 2 ? values.email : values.phone,
                  fieldToEdit
                );
              }
            }}>
            <Column className="profile-information-container">
              <Row className="profile-row-edit-data">
                <Column className="profile-column-edit-data">
                  <Row className="m-0">
                    {' '}
                    <p
                      className={`mb-1${editing && ' pl-3'}`}
                      style={{
                        ...fonts.SM,
                        color: colors.black,
                      }}>
                      {labels?.myProfile_nameLabel}
                    </p>
                  </Row>
                  <Row className="profile-input-row m-0">
                    {fieldToEdit === 1 ? (
                      <AppFormField
                        showErrorMessage
                        id="name"
                        className="profile-input"
                        name="name"
                        handleFormikContext={(formik) => {
                          if (values !== (formik as any).values) {
                            setValues(formik.values);
                          }
                          if (errors !== (formik as any).errors) {
                            setErrors(formik.errors);
                          }
                        }}
                        onMouseOver={(e) => {
                          defineOnMouseFunctions(e, 'name');
                        }}></AppFormField>
                    ) : (
                      <>
                        <p
                          className={`mb-1${editing && ' pl-3'}`}
                          style={{
                            ...fonts.SM,
                            ...fonts.SemiBold,
                            color: colors.black,
                            paddingBottom: '20px',
                          }}>
                          {values.name}
                        </p>
                        <Icon
                          name={Icons.PENCIL}
                          width="15.5"
                          height="15.5"
                          color={buStyles?.primaryColor}
                          viewBox={'0 0 24 24'}
                          onClick={() => {
                            setEditing(true);
                            setFieldToEdit(1);
                          }}
                          className="pencil-icon"
                          style={{minWidth: '15.5', minHeight: '15.5'}}
                        />
                      </>
                    )}
                    {hoverErrorIcons.name && (
                      <AppErrorMessage
                        message={errors && errors.name}
                        className={
                          errors &&
                          errors.name === labels?.myProfile_nameValidationError
                            ? 'profile-pop-up-error-messages-name-match'
                            : 'profile-pop-up-error-messages'
                        }
                      />
                    )}
                  </Row>

                  <Row className="profile-input-row m-0">
                    <p
                      className={`mb-1${editing && ' pl-3'}`}
                      style={{
                        ...fonts.SM,
                        color: colors.black,
                      }}>
                      {allLabels?.myProfile_contactLabel}
                    </p>
                  </Row>
                  <Row className="profile-input-row m-0">
                    {fieldToEdit === 2 ? (
                      <AppFormField
                        showErrorMessage
                        id="email"
                        className="profile-input"
                        name="email"
                        type="email"
                        onMouseOver={(e) => {
                          defineOnMouseFunctions(e, 'email');
                        }}></AppFormField>
                    ) : (
                      <>
                        <p
                          className={`mb-1${editing && ' pl-3'}`}
                          style={{
                            ...fonts.SM,
                            ...fonts.SemiBold,
                            color: colors.black,
                            paddingBottom: '20px',
                          }}>
                          {values.email}
                        </p>
                        <Icon
                          name={Icons.PENCIL}
                          width="15.5"
                          height="15.5"
                          color={buStyles?.primaryColor}
                          viewBox={'0 0 24 24'}
                          onClick={() => {
                            setEditing(true);
                            setFieldToEdit(2);
                          }}
                          className="pencil-icon"
                          style={{minWidth: '15.5', minHeight: '15.5'}}
                        />
                      </>
                    )}
                    {hoverErrorIcons.email && (
                      <AppErrorMessage
                        message={errors && errors.email}
                        className="profile-pop-up-error-messages"
                      />
                    )}
                  </Row>
                </Column>

                <Column className="profile-column-edit-data">
                  <Row className="m-0">
                    {' '}
                    <p
                      className={`mb-1${editing && ' pl-3'}`}
                      style={{
                        ...fonts.SM,
                        color: colors.black,
                      }}>
                      {labels?.myProfile_phoneNumberLabel}
                    </p>
                  </Row>
                  <Row className="profile-input-row m-0">
                    {fieldToEdit === 3 ? (
                      <AppFormField
                        showErrorMessage
                        id="phone"
                        className="profile-input"
                        name="phone"
                        maxLength={13}
                        modifyDisplayValue={(value) => numberWithSpaces(value)}
                        onMouseOver={(e) => {
                          defineOnMouseFunctions(e, 'phone');
                        }}></AppFormField>
                    ) : (
                      <>
                        <p
                          className={`mb-1${editing && ' pl-3'}`}
                          style={{
                            ...fonts.SM,
                            ...fonts.SemiBold,
                            color: colors.black,
                            paddingBottom: '20px',
                          }}>
                          {values.phone || '(nd)'}
                        </p>
                        <Icon
                          name={Icons.PENCIL}
                          width="15.5"
                          height="15.5"
                          color={buStyles?.primaryColor}
                          viewBox={'0 0 24 24'}
                          onClick={() => {
                            setEditing(true);
                            setFieldToEdit(3);
                          }}
                          className="pencil-icon"
                          style={{minWidth: '15.5', minHeight: '15.5'}}
                        />
                      </>
                    )}
                    {hoverErrorIcons.phone && (
                      <AppErrorMessage
                        message={errors && errors.phone}
                        className="profile-pop-up-error-messages"
                      />
                    )}
                  </Row>
                  <Row className="m-0">
                    {' '}
                    <p
                      className={`mb-1${editing && ' pl-3'}`}
                      style={{
                        ...fonts.SM,
                        color: colors.black,
                      }}>
                      {allLabels?.profile_registration_email}
                    </p>
                  </Row>
                  <Row className="profile-input-row m-0">
                    <p
                      className={`mb-1${editing && ' pl-3'}`}
                      style={{
                        ...fonts.SM,
                        ...fonts.SemiBold,
                        color: colors.black,
                      }}>
                      {user.username}
                    </p>
                  </Row>
                  {!editing && (
                    <Row className="profile-input-row m-0">
                      <a
                        className={`mb-1${editing && ' pl-3'}`}
                        style={{
                          ...fonts.SM,
                          ...fonts.SemiBold,
                          color: buStyles.primaryColor,
                          paddingBottom: '20px',
                        }}
                        onClick={() => setShowConfirmPassword(true)}>
                        {labels?.myProfile_updateEmail}
                      </a>
                    </Row>
                  )}
                </Column>
              </Row>
              <Row className="justify-content-center">
                {editing && (
                  <AppFormSubmitButton
                    disabled={submitting}
                    className="profile-save-button"
                    title={allLabels?.myProfile_button}
                  />
                )}
              </Row>
            </Column>
          </AppForm>
        )}
      </AuthConsumer>
      <Row>
        <p
          className="mb-1"
          style={{
            ...fonts.XL,
            color: colors.black,
          }}>
          {allLabels.profile_account_data_definitions}
        </p>
      </Row>
      <Row>
        <a
          className="profile-change-password-anchor"
          style={{
            ...fonts.M,
            ...fonts.Bold,
            color: buStyles?.primaryColor || colors.blue,
          }}
          onClick={() => setShowModal(true)}>
          {allLabels?.myProfile_changePassword}
        </a>
      </Row>
      <Row
        style={{
          ...fonts.M,
          ...fonts.Bold,
          color: buStyles?.primaryColor || colors.blue,
        }}
        onClick={() => setShowLanguageSelector(true)}>
        <span>{allLabels.profile_account_data_change_language}</span>
        <span
          style={{
            ...fonts.M,
            ...fonts.Regular,
            color: colors.lightGrey,
            paddingLeft: '30px',
          }}>
          {(stringsDefault?.pt?.register as any)[user?.language]}
        </span>
        <Icon
          color={buStyles.primary || colors.fluorescentBlue}
          name={Icons.CHEVRON_DOWN}
          className="app-nav-menu-arrow"
        />
      </Row>
      <Row>
        <a
          className="profile-change-password-anchor"
          style={{
            ...fonts.M,
            ...fonts.Bold,
            color: buStyles?.primaryColor || colors.blue,
          }}
          href="/permissoes">
          {allLabels.profile_account_data_manage_permissions}
        </a>
      </Row>
      <ModalTemplate
        inputType="confirm"
        show={showSaveResultModal}
        hideFooter={true}
        onHide={() => {}}>
        {saveOperationResult && (
          <div className="modal-error-container">
            <Row className="modal-success-title-row">
              {labels?.myProfile_pageTitle}
            </Row>
            <Row className="my-profile-submit-button-row">
              <Icon
                name={Icons.SUCCESS}
                className="success-icon"
                width={'24'}
                height={'24'}
                color={colors.black}
                changeViewbox
              />
            </Row>
            <Row className="my-profile-modal-success">
              {labels?.myProfile_saveSucceeded}
            </Row>
            <Row className="my-profile-submit-button-row">
              <AppFormSubmitButton
                title="Ok"
                className="stepper-continue-button"
                variant="secondary"
                onClick={() => {
                  setShowSaveResultModal(false);
                  setShowValidateModal(false);
                  setEditing(false);
                  setFieldToEdit(0);
                }}
              />
            </Row>
          </div>
        )}
        <ChangePasswordModal
          showModal={showModal}
          setShowModal={setShowModal}
        />
        {!saveOperationResult && (
          <div className="modal-error-container">
            <Row className="my-profile-submit-button-row">
              <Icon
                name={Icons.ALERT_PROBLEM}
                width={'40'}
                height={'40'}
                color={colors.alertRed}
                changeViewbox
              />
            </Row>
            <Row style={{...fonts.Bold, ...fonts.M, color: colors.alertRed}}>
              {labels?.myProfile_saveFailed}
            </Row>
            <Row className="my-profile-submit-button-row">
              <AppFormSubmitButton
                title="Ok"
                className="stepper-continue-button"
                variant="secondary"
                onClick={() => {
                  setShowSaveResultModal(false);
                }}
              />
            </Row>
          </div>
        )}
      </ModalTemplate>
      <ConfirmPasswordModal
        show={showConfirmPassword}
        setShow={setShowConfirmPassword}
      />
      <ChangePasswordModal showModal={showModal} setShowModal={setShowModal} />
      <AppLanguageSelector
        show={showLanguageSelector}
        setShow={setShowLanguageSelector}
      />
      <ValidateContactModal
        showModal={showValidateModal}
        setShowModal={setShowValidateModal}
        fieldEdited={fieldToEdit}
        setFieldEdited={setFieldToEdit}
        valueChanged={valueChanged}
        submit={submitCode}
        sendingNewCode={sendingNewCode}
        setSendingNewCode={setSendingNewCode}
        sendCode={sendCode}
        showResendConfirmation={showResendConfirmation}
        showWrongCodeError={showWrongCodeError}
        showSubmitCodeError={showSubmitCodeError}
        setShowWrongCodeError={setShowWrongCodeError}
        setShowSubmitCodeError={setShowSubmitCodeError}
        showCodeResendError={showCodeResendError}
        codeErrorMsg={codeErrorMsg}
      />
      {showCodeErrorModal && (
        <ModalTemplate
          type="error"
          show={showCodeErrorModal}
          onHide={() => setShowCodeErrorModal(false)}
          hideFooter={true}
          cross={true}>
          <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
            {codeErrorMsg}
          </p>{' '}
        </ModalTemplate>
      )}
    </>
  );
};

const mapStateToProps = ({
  strings,
  globalStyles,
  user,
  language,
  selectedBu,
  accessToken,
  stringsDefault,
}: any) => ({
  labels: {...strings.value.pt.myProfile, ...strings.value.pt.myData},
  buStyles: globalStyles.value,
  user: user.value,
  messageLabels: strings.value.pt.messages,
  stringsDefault: stringsDefault.value,
  language: language.value,
  selectedBu: selectedBu.value,
  accessToken: accessToken.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setUser: (value: any) => dispatch(setUser(value)),
  addToUser: (value: any) => dispatch(addToUser(value)),
});
export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AccountData)
);
